import { render, staticRenderFns } from "./TenantValid.vue?vue&type=template&id=67d98574&scoped=true"
import script from "./TenantValid.vue?vue&type=script&lang=js"
export * from "./TenantValid.vue?vue&type=script&lang=js"
import style0 from "./TenantValid.vue?vue&type=style&index=0&id=67d98574&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d98574",
  null
  
)

export default component.exports